import { useId } from 'react';

export function HouseIcon({
  size = 120,
  className,
  title = 'House logo',
  desc,
  ...props
}) {
  const uid = useId();
  const titleId = `house-title-${uid}`;
  const descId = `house-desc-${uid}`;
  const roofLeftId = `roof-left-${uid}`;
  const roofRightId = `roof-right-${uid}`;
  const frontId = `front-${uid}`;
  const sideId = `side-${uid}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby={desc ? `${titleId} ${descId}` : titleId}
      className={className}
      {...props}
    >
      <title id={titleId}>{title}</title>
      {desc ? <desc id={descId}>{desc}</desc> : null}

      <defs>
        <linearGradient id={roofLeftId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--app-theme)" />
          <stop offset="100%" stopColor="var(--app-theme)" opacity="0.8" />
        </linearGradient>
        <linearGradient id={roofRightId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--app-theme)" opacity="0.9" />
          <stop offset="100%" stopColor="var(--app-theme)" opacity="0.6" />
        </linearGradient>
        <linearGradient id={frontId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--app-theme)" opacity="1.1" />
          <stop offset="100%" stopColor="var(--app-theme)" opacity="0.7" />
        </linearGradient>
        <linearGradient id={sideId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--app-theme)" opacity="0.85" />
          <stop offset="100%" stopColor="var(--app-theme)" opacity="0.55" />
        </linearGradient>
      </defs>

      {/* Ground shadow */}
      <ellipse
        cx="60"
        cy="110"
        rx="34"
        ry="6"
        fill="var(--app-component-color)"
        opacity="0.15"
      />

      {/* House group - lifted up 5px */}
      <g transform="translate(0, -5)">
        {/* Left roof face */}
        <polygon
          points="28,58 50,34 60,34 72,58"
          fill={`url(#${roofLeftId})`}
        />

        {/* Chimney */}
        <g>
          <rect
            x="80"
            y="34"
            width="10"
            height="20"
            fill="var(--app-theme)"
            opacity="0.6"
            stroke="var(--app-component-color)"
            strokeOpacity="0.3"
            strokeWidth="0.5"
          />
          <rect
            x="78"
            y="30"
            width="14"
            height="4"
            fill="var(--app-theme)"
            opacity="0.4"
            stroke="var(--app-component-color)"
            strokeOpacity="0.3"
            strokeWidth="0.5"
          />
          <polygon
            points="80,47 90,53 90,55 80,49"
            fill="var(--app-component-color)"
            opacity="0.15"
          />
        </g>

        {/* Right roof face */}
        <polygon
          points="72,58 60,34 98,58"
          fill={`url(#${roofRightId})`}
        />

        {/* Front wall */}
        <polygon
          points="28,58 72,58 72,104 28,104"
          fill={`url(#${frontId})`}
        />

        {/* Right side wall */}
        <polygon
          points="72,58 98,58 98,104 72,104"
          fill={`url(#${sideId})`}
        />

        {/* Door */}
        <rect
          x="48"
          y="72"
          width="12"
          height="32"
          fill="var(--app-component-color)"
          opacity="0.8"
        />

        {/* Outline group */}
        <g
          fill="none"
          stroke="var(--app-component-color)"
          strokeOpacity="0.18"
          strokeWidth="1"
          strokeLinejoin="miter"
        >
          <polygon points="28,58 50,34 60,34 72,58" />
          <polygon points="72,58 60,34 98,58" />
          <polygon points="28,58 72,58 72,104 28,104" />
          <polygon points="72,58 98,58 98,104 72,104" />
          <rect x="48" y="72" width="12" height="32" />
          <rect x="80" y="34" width="10" height="20" />
          <rect x="78" y="30" width="14" height="4" />
          <polygon points="80,47 90,53 90,55 80,49" />
        </g>
      </g>
    </svg>
  );
}